/**
 * Safely embed a JS object as JSON-LD inside a `<script type="application/ld+json">`.
 *
 * Even though our Schema.org data is admin-controlled (yacht descriptions,
 * destination copy, FAQs), we defensively escape the `</` sequence so that
 * a future field can never accidentally break out of the script tag and
 * inject HTML/JS. This is the React-equivalent of the long-standing
 * server-side `</script>` escape pattern.
 *
 * Reference: https://github.com/facebook/react/issues/27072
 */
export function jsonLd(data) {
  return JSON.stringify(data).replace(/</g, '\\u003c');
}
